import { envExports } from "../pkExports.js";
export async function postSubmit(d, fn) {
  await new Promise((r) => setTimeout(r, 500));
  const { requestURL, requestPUT } = envExports;
  fetch(`${requestURL}`, requestPUT(d)).then((r) => fn(r.status));
}
export function postStyle() {
  return (theme) => ({
    ...{
      mb: 4,
      "& .MuiInputLabel-root.Mui-disabled, & .MuiInputLabel-root": {
        color: theme.palette.grey[500],
      },
      "& .MuiInputBase-root.Mui-disabled": {
        color: theme.palette.grey[400],
      },
      "& .MuiInputBase-root": {
        "& input::placeholder, & textarea::placeholder": {
          color: theme.palette.grey[500],
        },
        border: 2,
        borderRadius: "4px",
        borderColor: theme.palette.grey[500],
        color: theme.palette.grey[700],
      },
    },
  });
}
